import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ModalWrapper } from '../common';

export default function AccountDeleteCompleteModal({ onClose }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    onClose();
    navigate('/');
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 2000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ModalWrapper onClose={handleClose} padding="px-5 sm:px-8 py-8 sm:py-10" gap="">
      {/* Title */}
      <h2 className="text-xl font-bold text-mono-900 text-center">
        {t('common.account_delete_complete_title')}
      </h2>

      {/* Subtitle */}
      <p className="text-sm text-mono-500 text-center mt-3">
        {t('common.account_delete_complete_desc')}
      </p>
    </ModalWrapper>
  );
}
